var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSidebarWorkflowIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1012_3414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7495 11.998H12.7495C12.3353 11.998 11.9995 12.3338 11.9995 12.748V15.748C11.9995 16.1623 12.3353 16.498 12.7495 16.498H15.7495C16.1637 16.498 16.4995 16.1623 16.4995 15.748V12.748C16.4995 12.3338 16.1637 11.998 15.7495 11.998Z",
    stroke: "#E2E8F0",
    strokeWidth: 1.26,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25049 11.998H2.25049C1.83627 11.998 1.50049 12.3338 1.50049 12.748V15.748C1.50049 16.1623 1.83627 16.498 2.25049 16.498H5.25049C5.6647 16.498 6.00049 16.1623 6.00049 15.748V12.748C6.00049 12.3338 5.6647 11.998 5.25049 11.998Z",
    stroke: "#E2E8F0",
    strokeWidth: 1.26,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 1.5H7.5C7.08579 1.5 6.75 1.83579 6.75 2.25V5.25C6.75 5.66421 7.08579 6 7.5 6H10.5C10.9142 6 11.25 5.66421 11.25 5.25V2.25C11.25 1.83579 10.9142 1.5 10.5 1.5Z",
    stroke: "#E2E8F0",
    strokeWidth: 1.26,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75049 12V9.75C3.75049 9.55109 3.82951 9.36032 3.97016 9.21967C4.11081 9.07902 4.30158 9 4.50049 9H13.5005C13.6994 9 13.8902 9.07902 14.0308 9.21967C14.1715 9.36032 14.2505 9.55109 14.2505 9.75V12",
    stroke: "#E2E8F0",
    strokeWidth: 1.26,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 9V6",
    stroke: "#E2E8F0",
    strokeWidth: 1.26,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1012_3414"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarWorkflowIcon);
export default __webpack_public_path__ + "static/media/sidebarWorkflowIcon.24ccc592570b82dae2e91fb74a5660e1.svg";
export { ForwardRef as ReactComponent };